module.exports = __webpack_public_path__ + "img/sense.4f206ba7.png";